import { getResizedImageUrl } from '@wix/media-manager';
export var getLogoUrl = function (logo, _a) {
    var _b;
    var maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
    var logoFilename = (_b = logo.match(/(?:[^\/]+)$/)) === null || _b === void 0 ? void 0 : _b[0];
    if (!logoFilename) {
        return;
    }
    if (logoFilename.endsWith('.svg')) {
        return "https://static.wixstatic.com/shapes/".concat(logoFilename);
    }
    var resizedLogoUrl = getResizedImageUrl(logoFilename, maxWidth, maxHeight);
    return resizedLogoUrl.replace('/fill/', '/fit/');
};
//# sourceMappingURL=getLogoUrl.js.map